import { jsx as _jsx } from "react/jsx-runtime";
import ImageBlockComponent from '../../../image';
const ImageBlock = ({ value }) => (_jsx(ImageBlockComponent, { imageUrl: value.imageUrl, caption: value.caption, copyright: value.copyright, size: value.size, alternativeText: value.alternativeText }));
export default ImageBlock;
